var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "block-editor create-task" }, [
    _c("div", { staticClass: "wrapper" }, [
      _c(
        "section",
        [
          _c("div", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("message.workflow"))),
          ]),
          _vm._v(" "),
          _c("CustomPicker", {
            attrs: {
              items: _vm.workflows,
              idKey: "_id",
              labelKey: "title",
              placeholder: _vm.$t("message.selectWorkflow"),
            },
            model: {
              value: _vm.clone.workflowId,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "workflowId", $$v)
              },
              expression: "clone.workflowId",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "section",
        [
          _c("div", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("message.pipelineStage"))),
          ]),
          _vm._v(" "),
          _c("CustomPicker", {
            attrs: {
              items: _vm.filteredPipelineStages,
              idKey: "_id",
              labelKey: "name",
              placeholder: _vm.$t("message.selectPipelineStage"),
            },
            model: {
              value: _vm.clone.pipelineStageId,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "pipelineStageId", $$v)
              },
              expression: "clone.pipelineStageId",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "section",
        [
          _c("div", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("message.title"))),
          ]),
          _vm._v(" "),
          _c("TiptapEditor", {
            attrs: {
              placeholder: _vm.$t("message.taskTitle"),
              "show-attributes": true,
              "automation-mode": "",
            },
            model: {
              value: _vm.clone.title,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "title", $$v)
              },
              expression: "clone.title",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "section",
        [
          _c("div", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("message.description"))),
          ]),
          _vm._v(" "),
          _c("TiptapEditor", {
            attrs: {
              placeholder: _vm.$t("message.taskDescription"),
              "show-attributes": true,
              "automation-mode": "",
            },
            model: {
              value: _vm.clone.description,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "description", $$v)
              },
              expression: "clone.description",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "section",
        [
          _c("div", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("message.priority"))),
          ]),
          _vm._v(" "),
          _c("CustomPicker", {
            attrs: {
              items: _vm.priorityOptions,
              idKey: "value",
              labelKey: "label",
              placeholder: _vm.$t("message.selectPriority"),
            },
            model: {
              value: _vm.clone.priority,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "priority", $$v)
              },
              expression: "clone.priority",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "section",
        [
          _c("div", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("message.assignees"))),
          ]),
          _vm._v(" "),
          _vm._l(_vm.clone.assigneeIds, function (assignee, index) {
            return _c(
              "div",
              { key: index, staticClass: "dynamic-field" },
              [
                _c(
                  "div",
                  { staticClass: "field-header" },
                  [
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.$t("message.assignee")) +
                          " " +
                          _vm._s(index + 1)
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "mode-switch" },
                      [
                        _c("span", { staticClass: "switch-label" }, [
                          _vm._v(_vm._s(_vm.$t("message.dynamic"))),
                        ]),
                        _vm._v(" "),
                        _c("a-switch", {
                          attrs: {
                            size: "small",
                            checked: assignee.mode === "dynamic",
                          },
                          on: {
                            change: function (checked) {
                              return _vm.onModeChange(checked, assignee)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "SupsisButton",
                      {
                        attrs: { icon: "", danger: "", xsmall: "" },
                        on: {
                          click: function ($event) {
                            return _vm.removeAssignee(index)
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("delete"),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                assignee.mode === "static"
                  ? [
                      _c("CustomPicker", {
                        attrs: {
                          items: _vm.userOptions,
                          idKey: "_id",
                          labelKey: "name",
                          placeholder: _vm.$t("message.selectUser"),
                        },
                        model: {
                          value: assignee.value,
                          callback: function ($$v) {
                            _vm.$set(assignee, "value", $$v)
                          },
                          expression: "assignee.value",
                        },
                      }),
                    ]
                  : [
                      _c("TiptapEditor", {
                        attrs: {
                          placeholder: _vm.$t("message.dynamicValue"),
                          "show-attributes": true,
                          "automation-mode": "",
                        },
                        model: {
                          value: assignee.value,
                          callback: function ($$v) {
                            _vm.$set(assignee, "value", $$v)
                          },
                          expression: "assignee.value",
                        },
                      }),
                    ],
              ],
              2
            )
          }),
          _vm._v(" "),
          _c(
            "a-button",
            {
              attrs: { type: "dashed", block: "" },
              on: { click: _vm.addAssignee },
            },
            [
              _c("a-icon", { attrs: { type: "plus" } }),
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t("message.addAssignee")) +
                  "\n            "
              ),
            ],
            1
          ),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "section",
        [
          _c("div", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("message.followers"))),
          ]),
          _vm._v(" "),
          _vm._l(_vm.clone.followers, function (follower, index) {
            return _c(
              "div",
              { key: index, staticClass: "dynamic-field" },
              [
                _c(
                  "div",
                  { staticClass: "field-header" },
                  [
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.$t("message.follower")) +
                          " " +
                          _vm._s(index + 1)
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "mode-switch" },
                      [
                        _c("span", { staticClass: "switch-label" }, [
                          _vm._v(_vm._s(_vm.$t("message.dynamic"))),
                        ]),
                        _vm._v(" "),
                        _c("a-switch", {
                          attrs: {
                            size: "small",
                            checked: follower.mode === "dynamic",
                          },
                          on: {
                            change: function (checked) {
                              return _vm.onFollowerModeChange(checked, follower)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "SupsisButton",
                      {
                        attrs: { icon: "", danger: "", xsmall: "" },
                        on: {
                          click: function ($event) {
                            return _vm.removeFollower(index)
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("delete"),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                follower.mode === "static"
                  ? [
                      _c("CustomPicker", {
                        attrs: {
                          items: _vm.userOptions,
                          idKey: "_id",
                          labelKey: "name",
                          placeholder: _vm.$t("message.selectFollower"),
                        },
                        model: {
                          value: follower.value,
                          callback: function ($$v) {
                            _vm.$set(follower, "value", $$v)
                          },
                          expression: "follower.value",
                        },
                      }),
                    ]
                  : [
                      _c("TiptapEditor", {
                        attrs: {
                          placeholder: _vm.$t("message.dynamicValue"),
                          "show-attributes": true,
                          "automation-mode": "",
                        },
                        model: {
                          value: follower.value,
                          callback: function ($$v) {
                            _vm.$set(follower, "value", $$v)
                          },
                          expression: "follower.value",
                        },
                      }),
                    ],
              ],
              2
            )
          }),
          _vm._v(" "),
          _c(
            "a-button",
            {
              attrs: { type: "dashed", block: "" },
              on: { click: _vm.addFollower },
            },
            [
              _c("a-icon", { attrs: { type: "plus" } }),
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t("message.addFollower")) +
                  "\n            "
              ),
            ],
            1
          ),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "section",
        [
          _c("div", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("message.collaborators"))),
          ]),
          _vm._v(" "),
          _vm._l(_vm.clone.collaborators, function (collaborator, index) {
            return _c(
              "div",
              { key: index, staticClass: "dynamic-field" },
              [
                _c(
                  "div",
                  { staticClass: "field-header" },
                  [
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.$t("message.collaborator")) +
                          " " +
                          _vm._s(index + 1)
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "mode-switch" },
                      [
                        _c("span", { staticClass: "switch-label" }, [
                          _vm._v(_vm._s(_vm.$t("message.dynamic"))),
                        ]),
                        _vm._v(" "),
                        _c("a-switch", {
                          attrs: {
                            size: "small",
                            checked: collaborator.mode === "dynamic",
                          },
                          on: {
                            change: function (checked) {
                              return _vm.onCollaboratorModeChange(
                                checked,
                                collaborator
                              )
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "SupsisButton",
                      {
                        attrs: { icon: "", danger: "", xsmall: "" },
                        on: {
                          click: function ($event) {
                            return _vm.removeCollaborator(index)
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("delete"),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                collaborator.mode === "static"
                  ? [
                      _c("CustomPicker", {
                        attrs: {
                          items: _vm.userOptions,
                          idKey: "_id",
                          labelKey: "name",
                          placeholder: _vm.$t("message.selectCollaborator"),
                        },
                        model: {
                          value: collaborator.value,
                          callback: function ($$v) {
                            _vm.$set(collaborator, "value", $$v)
                          },
                          expression: "collaborator.value",
                        },
                      }),
                    ]
                  : [
                      _c("TiptapEditor", {
                        attrs: {
                          placeholder: _vm.$t("message.dynamicValue"),
                          "show-attributes": true,
                          "automation-mode": "",
                        },
                        model: {
                          value: collaborator.value,
                          callback: function ($$v) {
                            _vm.$set(collaborator, "value", $$v)
                          },
                          expression: "collaborator.value",
                        },
                      }),
                    ],
              ],
              2
            )
          }),
          _vm._v(" "),
          _c(
            "a-button",
            {
              attrs: { type: "dashed", block: "" },
              on: { click: _vm.addCollaborator },
            },
            [
              _c("a-icon", { attrs: { type: "plus" } }),
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t("message.addCollaborator")) +
                  "\n            "
              ),
            ],
            1
          ),
        ],
        2
      ),
      _vm._v(" "),
      _c("section", [
        _c("div", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("message.owner"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "dynamic-field" },
          [
            _c("div", { staticClass: "field-header" }, [
              _c(
                "div",
                { staticClass: "mode-switch" },
                [
                  _c("span", { staticClass: "switch-label" }, [
                    _vm._v(_vm._s(_vm.$t("message.dynamic"))),
                  ]),
                  _vm._v(" "),
                  _c("a-switch", {
                    attrs: {
                      size: "small",
                      checked: _vm.clone.ownerId.mode === "dynamic",
                    },
                    on: {
                      change: function (checked) {
                        return _vm.onOwnerModeChange(checked)
                      },
                    },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _vm.clone.ownerId.mode === "static"
              ? [
                  _c("CustomPicker", {
                    attrs: {
                      items: _vm.userOptions,
                      idKey: "_id",
                      labelKey: "name",
                      placeholder: _vm.$t("message.selectOwner"),
                    },
                    model: {
                      value: _vm.clone.ownerId.value,
                      callback: function ($$v) {
                        _vm.$set(_vm.clone.ownerId, "value", $$v)
                      },
                      expression: "clone.ownerId.value",
                    },
                  }),
                ]
              : [
                  _c("TiptapEditor", {
                    attrs: {
                      placeholder: _vm.$t("message.enterOwnerId"),
                      "show-attributes": true,
                      "automation-mode": "",
                    },
                    model: {
                      value: _vm.clone.ownerId.value,
                      callback: function ($$v) {
                        _vm.$set(_vm.clone.ownerId, "value", $$v)
                      },
                      expression: "clone.ownerId.value",
                    },
                  }),
                ],
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _c("section", [
        _c("div", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("message.tags"))),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "add-tags" }, [
          _c(
            "div",
            {
              staticStyle: {
                "margin-top": "10px",
                color: "#ec4b1d",
                "font-weight": "bold",
                cursor: "pointer",
                display: "flex",
                "align-items": "center",
              },
            },
            [
              _vm._v(
                "\n                    " +
                  _vm._s(_vm.$t("message.addTag")) +
                  "\n                    "
              ),
              _c(
                "a-dropdown",
                [
                  _c(
                    "a-button",
                    { staticStyle: { "margin-left": "10px", padding: "2px" } },
                    [
                      _c("span", { staticClass: "material-icons" }, [
                        _vm._v("add"),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-menu",
                    { attrs: { slot: "overlay" }, slot: "overlay" },
                    [
                      _vm.tags && _vm.tags.length > 0
                        ? _vm._l(_vm.tags, function (tag) {
                            return _c(
                              "a-menu-item",
                              {
                                key: tag._id,
                                staticStyle: {
                                  display: "flex",
                                  "align-items": "center",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.selectTag(tag)
                                  },
                                },
                              },
                              [
                                _c("div", {
                                  staticClass: "showColor",
                                  style: {
                                    backgroundColor: tag.color || "#cccccc",
                                    width: "20px",
                                    height: "20px",
                                    borderRadius: "5px",
                                    marginRight: "8px",
                                  },
                                }),
                                _vm._v(" "),
                                _c("span", [_vm._v(_vm._s(tag.name))]),
                              ]
                            )
                          })
                        : _c("a-menu-item", { attrs: { disabled: "" } }, [
                            _c("span", [_vm._v("Etiket bulunamadı")]),
                          ]),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.clone.tags && _vm.clone.tags.length > 0
            ? _c(
                "div",
                { staticClass: "selected-tags" },
                _vm._l(_vm.clone.tags, function (tag) {
                  return _c(
                    "div",
                    {
                      key: tag._id,
                      staticClass: "tag-item",
                      style: _vm.getTagStyle(tag.color),
                    },
                    [
                      _c("span", [_vm._v(_vm._s(tag.name))]),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "material-icons close-icon",
                          on: {
                            click: function ($event) {
                              return _vm.removeTag(tag._id)
                            },
                          },
                        },
                        [_vm._v("close")]
                      ),
                    ]
                  )
                }),
                0
              )
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "section",
        [
          _c("div", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("message.contactId"))),
          ]),
          _vm._v(" "),
          _c("TiptapEditor", {
            attrs: {
              placeholder: _vm.$t("message.contactIdPlaceholder"),
              "show-attributes": true,
              "automation-mode": "",
            },
            model: {
              value: _vm.clone.contactId,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "contactId", $$v)
              },
              expression: "clone.contactId",
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }